import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile, userInfoStore, RightContainer, useTranslation } from '@pascal/pascal-core';

import { LiveBetsWrapper } from '../liveBetsWrapper';
import { globalTranslationKeys } from '../../../enums';
import { BetHistoryWrapper } from '../betHistoryWrapper';
import { useDemoSwitcher } from '../../../hooks/useDemoSwitcher';
import { ResultTopWinContainer } from '../resultTopWinContainer';

const RightColumn = observer(() => {
  const { demoSwitcherAdditionalFunction } = useDemoSwitcher();

  const { LiveBets, History, Results, TopWinners } = globalTranslationKeys;

  const { currencyCode } = userInfoStore;

  const t = useTranslation();

  const rightContainerTabs = useMemo(
    () => [
      { name: LiveBets },
      { name: History, isBetHistory: true },
      { name: isMobile() ? TopWinners : Results },
    ],
    [isMobile()]
  );

  const rightContainerTabsContainers = useMemo(
    () => [
      <LiveBetsWrapper t={t} currencySymbol={currencyCode} />,
      <BetHistoryWrapper />,
      <ResultTopWinContainer />,
    ],
    []
  );

  return (
    <RightContainer
      hasChat
      hasFreeBets
      hasHalfCashOut
      hasSoundControllerRow
      hasMusicControllerRow
      tabs={rightContainerTabs}
      demoSwitcherAdditionalFunction={demoSwitcherAdditionalFunction}
      tabContainers={rightContainerTabsContainers}
    />
  );
});

export default RightColumn;
